import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PLAYER_A_CARD_HAND,
  PLAYER_B_CARD_HAND,
} from '../../../constants/cards';

type Hand = typeof PLAYER_A_CARD_HAND | typeof PLAYER_B_CARD_HAND;

type Card = {
  CardName: string;
  CardValue: number;
};

export type CardsState = Record<Hand, { cards: Card[] }>;

const INITIAL_STATE: CardsState = {
  [PLAYER_A_CARD_HAND]: { cards: [] },
  [PLAYER_B_CARD_HAND]: { cards: [] },
};

const cardsSlice = createSlice({
  name: 'cards',
  initialState: INITIAL_STATE,
  reducers: {
    set(state, { payload }: PayloadAction<Partial<CardsState>>) {
      return { ...state, ...payload };
    },
    reset() {
      return INITIAL_STATE;
    },
  },
});

export const cardsActions = { cards: cardsSlice.actions };

export default cardsSlice.reducer;
